"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
@keyframes overlay-open-animation {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  
  @keyframes overlay-close-animation {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2147483647;
    background-image: radial-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.8));
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .overlay-open {
    @extend .overlay;
    animation: overlay-open-animation 0.3s linear;
    opacity: 1;
  }
  
  .overlay-close {
    @extend .overlay;
    animation: overlay-close-animation 0.3s linear;
    opacity: 0;
  }
  
  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 48px;
    height: 48px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .content {
    width: 100%;
    max-width: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .klarna-button {
    background-color: white;
    border: none;
    cursor: pointer;
    outline: 0;
    -webkit-tap-highlight-color: transparent;
    border-radius: 20px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 9px 14px 9px 16px;
    color: rgb(23, 23, 23);
    font-family: 'Klarna Text', 'Klarna Sans', Helvetica, Arial, sans-serif;
    font-weight: 500;
    font-size: 14px;
    text-rendering: geometricPrecision;
    -webkit-font-smoothing: antialiased;
    line-height: 20px;
  }
  
  .klarna-logo {
    width: 120px;
    max-width: 100%;
    height: auto;
  }
  
  .text-content {
    color: white;
    font-family: 'Klarna Text', 'Klarna Sans', Helvetica, Arial, sans-serif;
    font-size: 14px;
    text-rendering: geometricPrecision;
    -webkit-font-smoothing: antialiased;
    line-height: 20px;
    text-align: center;
    margin: 20px 0;
  }
  
`;
